import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/cart/cartErrors.scss';

export const CartErrors = ({ cart, isModal = false }) => {
  const {
    testId,
    marketplace: { cart: { cartName } }
  } = useMartyContext();

  const { error, cartObj: { savedItems } } = cart;

  return (
    (savedItems?.length || error) &&
      <div className={cn(css.container, { [css.modal]: isModal })}>
        <p data-test-id={testId('cartError')}>{error}</p>

        { !!savedItems?.length &&
          <p data-test-id={testId('oosError')}>An item in your {cartName} is out of stock. It will not show when you proceed to checkout.</p>
        }
      </div>
  );

};

export const mapStateToProps = state => {
  const { cart } = state;

  return {
    cart
  };
};

const ConnectedCartErrors = connect(mapStateToProps, {})(CartErrors);
export default withErrorBoundary('CartErrors', ConnectedCartErrors);
